import React, { FunctionComponent } from "react";

export const ForgotPasswordForm: FunctionComponent = () => (
  <div>ForgotPasswordForm</div>
);
